import "./component-library115.mjs";
import normalizeComponent from "./component-library92.mjs";
const _sfc_main = {
  name: "Toggle",
  props: {
    value: { type: Boolean },
    label: { type: String, default: null },
    disabled: { type: Boolean }
  },
  emits: ["input"],
  computed: {
    containerClass() {
      return {
        "toggle--disabled": this.disabled,
        "toggle--active": this.value
      };
    }
  },
  methods: {
    change() {
      if (this.disabled)
        return;
      this.$emit("input", !this.value);
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("label", { staticClass: "toggle", class: _vm.containerClass }, [_c("input", { staticClass: "toggle__checkbox", attrs: { "type": "checkbox" }, domProps: { "checked": _vm.value }, on: { "change": _vm.change } }), _vm._m(0), _c("span", { staticClass: "toggle__label" }, [_vm._t("default", function() {
    return [_c("span", { domProps: { "innerHTML": _vm._s(_vm.label) } })];
  })], 2)]);
};
var _sfc_staticRenderFns = [function() {
  var _vm = this, _c = _vm._self._c;
  return _c("span", { staticClass: "toggle__controls" }, [_c("span", { staticClass: "toggle__bullet" })]);
}];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "210b87df",
  null,
  null
);
const toggle = __component__.exports;
export {
  toggle as default
};
